import angular, { ILogService, INgModelController, ITimeoutService } from 'angular'
import { Datepicker } from 'materialize-css'
import moment from 'moment'

class MaterialDateDirective implements ng.IDirective {
  private datepickerInstance: Datepicker

  bindToController = true
  require = {
    ngModel: 'ngModel',
  }

  constructor(private $log: ILogService, private $timeout: ITimeoutService) {}

  link = (scope: ng.IScope, $element: JQLite, attrs: ng.IAttributes, ctrls: { ngModel: INgModelController }) => {
    this.$log.info('==== date attr', attrs)

    scope.$watch(attrs.ngModel, (newVal: null | Date | string, oldVal) => {
      this.$log.info('== datemodel', newVal, scope, $element, ctrls)

      // scope.$eval("attrs.ngModel = 'foooo0'")
      ctrls.ngModel.$modelValue = new Date(newVal as string)
      // ctrls.ngModel.$processModelValue()

      if (!this.datepickerInstance) {
        this._initInstance($element)
      }

      this.datepickerInstance.setDate(null)
    })

    this.$timeout(() => this._initInstance($element), 100)
  }

  private _initInstance($element: JQLite) {
    let m = moment('01/01/1940', 'dd/mm/YYYY')
    let max = moment().add(10, 'y')

    this.$log.info('mindate', m)

    return (this.datepickerInstance = M.Datepicker.init($element[0], {
      autoClose: true,
      minDate: m.toDate(),
      maxDate: max.toDate(),
      yearRange: [1950, max.year()],
      firstDay: 1,
      container: document.body,
      // onOpen: function () {
      //   angular.element(document.body).addClass('datepicker-open')
      // },
      // onClose: function () {
      //   angular.element(document.body).removeClass('datepicker-open')
      // },
    }))
  }
}

angular
  .module('candidato')
  .directive(
    'materialDateCaxton',
    ($log: ILogService, $timeout: ITimeoutService) => new MaterialDateDirective($log, $timeout)
  )
